// extracted by mini-css-extract-plugin
export default {"row":"home_row__88of4"};